import { httpGet, httpPost } from '../../common/http-client';

export async function login(email: string): Promise<void> {
    await httpPost('/api/auth/login', email);
}

export async function requestToken(oneTimeToken: string): Promise<string> {
    return await httpGet<string>(`/api/auth/token/${oneTimeToken}`);
}
